import React from "react";

// Marks a run or queue row that was captured by hand in DWW Browser (the
// browser split queue) rather than by screenhunter. Sized in em so it follows
// the zoom level of the heading it sits in.
const BrowserBadge = ({ className = "" }) => (
  <span
    className={`dib navy bg-lightest-blue fw6 br1 ${className}`}
    style={{
      fontSize: "0.8em",
      padding: "0 0.4em",
      lineHeight: 1.5,
      verticalAlign: "middle",
    }}
    title="Captured by hand in DWW Browser (browser split queue), not by screenhunter"
  >
    Browser
  </span>
);

export default BrowserBadge;
